import * as React from "react";
const SvgArrowLeft = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 17 16", xmlns: "http://www.w3.org/2000/svg", fill: "#FFF", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M5.384 8.667l3.576 3.576-.943.942L2.832 8l5.185-5.185.943.942-3.576 3.576h8.114v1.334z", fillRule: "evenodd" }));
export default SvgArrowLeft;
